import React, { useState } from 'react';
import TitleSection from 'components/common/TitleSection';
import CommonTab from 'components/common/tabs';
import SubPagesLayout from 'layouts/SubPagesLayout';
import TabsListing from 'components/common/tabs/TabsListing';
import {
  coperativeData,
  corporateMeetingData,
  executiveData,
  pressConferenceData,
  conferenceData,
  businessData,
  exhibitionData,
  awardData,
  techData,
  corporativeCardData,
  techCardData,
  awardCardData,
  exhibitionCardData,
  businessMeetCardData,
  conferenceCardData,
  pressCardData,
  executiveCardData,
  corporateMeetCardData,
  corporativeDetailPage
} from 'helpers/portfolioHelper';
import CommonDetail from 'components/common/CommonDetail';

const CorporatePage = () => {
  const titleDetail = {
    upperTitle: '',
    middleTitle: 'CORPORATIVE EVENTS',
    lowerTitle: 'WE HAVE BEST SOLUTIONS FOR ALL',
  };
  const [currentTab, setCurrentTab] = useState('product lunches');

  let [tabList] = useState([
    {
      id: 1,
      name: 'product lunches',
      component: (
        <TabsListing
          list={coperativeData.slice(1, 6)}
          cardData={corporativeCardData}
        />
      ),
    },
    {
      id: 2,
      name: 'Corporate Meetings',
      component: (
        <TabsListing
          list={corporateMeetingData.slice(1, 6)}
          cardData={corporateMeetCardData}
        />
      ),
    },
    {
      id: 3,
      name: 'Executive Events',
      component: (
        <TabsListing
          list={executiveData.slice(1, 6)}
          cardData={executiveCardData}
        />
      ),
    },
    {
      id: 4,
      name: 'Press Conference',
      component: (
        <TabsListing
          list={pressConferenceData.slice(1, 6)}
          cardData={pressCardData}
        />
      ),
    },
    {
      id: 5,
      name: 'Conference Meeting',
      component: (
        <TabsListing
          list={conferenceData.slice(1, 6)}
          cardData={conferenceCardData}
        />
      ),
    },
    {
      id: 6,
      name: 'Business Retrive Meeting',
      component: (
        <TabsListing
          list={businessData.slice(1, 6)}
          cardData={businessMeetCardData}
        />
      ),
    },
    {
      id: 7,
      name: 'Exhibitions Meeting',
      component: (
        <TabsListing
          list={exhibitionData.slice(1, 6)}
          cardData={exhibitionCardData}
        />
      ),
    },
    {
      id: 8,
      name: 'Award Ceremonies',
      component: (
        <TabsListing
          list={awardData.slice(1, 6)}
          cardData={awardCardData}
        />
      ),
    },
    {
      id: 9,
      name: 'Tech Event',
      component: (
        <TabsListing
          list={techData.slice(1, 6)}
          cardData={techCardData}
        />
      ),
    },
  ]);
  return (
    <>
      <section className='DBlock relative py-10 sm:py-12 px-6 sm:px-10 bg-eventLightPink'>
        <div className='max-w-7xl mx-auto'>
        <CommonDetail data={corporativeDetailPage}/>
          <div>
            <TitleSection titleDetail={titleDetail} />
            <CommonTab
              tabList={tabList}
              setCurrentTab={setCurrentTab}
              currentTab={currentTab}
              maxWidth='max-w-xl'
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default SubPagesLayout({ route: 'what we do/corporative event' })(
  CorporatePage
); 
